<script setup lang="ts">
    import {
        Collapsible,
        CollapsibleTrigger,
        CollapsibleContent,
    } from '@/components/ui/collapsible';
    import { createLogFilterColumns } from '@/tables/columns/log-filters';
    import LogFilterTable from '@/components/log/LogFilterTable.vue';
    import { useLogStore } from '@/stores/log';
    import { useQueryClient } from '@tanstack/vue-query';
    import QueryKey from '@/enums/QueryKey';

    const logStore = useLogStore();
    const queryClient = useQueryClient();

    const props = defineProps<{
        name: string;
        label: string;
        loading: boolean;
        data: any[];
    }>();

    const columns = createLogFilterColumns(props.label);

    const handleFilterSelection = (rowSelection: string[]) => {
        logStore.updateRowSelection(rowSelection, props.name);
        queryClient.invalidateQueries({ queryKey: [QueryKey.LOGS] });
        queryClient.invalidateQueries({ queryKey: [QueryKey.ACTIVITIES] });
    };
</script>

<template>
    <Collapsible
        :open="logStore.openFilters.has(props.name)"
        @update:open="logStore.toggleFilter(props.name)"
        class="rounded border align-top"
        :unmount-on-hide="false"
    >
        <CollapsibleTrigger>
            {{ $t(label) }}
        </CollapsibleTrigger>
        <CollapsibleContent>
            <div class="flex max-h-96 min-h-0 flex-1 flex-col gap-2 overflow-hidden px-2 pb-2">
                <LogFilterTable
                    :data="data"
                    :columns="columns"
                    :loading="loading"
                    class="overflow-auto"
                    @row-selection-change="handleFilterSelection"
                />
            </div>
        </CollapsibleContent>
    </Collapsible>
</template>
